export enum EnumFreshDeskTicketPriority {
  Low = 1,
  Medium = 2,
  High = 3,
  Urgent = 4,
}
